import { createSelector } from 'reselect';

export const getClient = (clients) => (clients ? clients.client : null);

export const getClientLogo = createSelector([getClient], (client) => {
  console.log(client && client.logo ? client.logo : null);
  return client && client.logo ? client.logo : null;
});
